import React from "react";
import "./style.css";
import { NavLink } from "react-router-dom";
import vikdata from "../../assets/photo/vikimg.jpeg";
import training_rule from "../../assets/pdf/Training_Rules.pdf";
import Gad from "../../assets/pdf/GAD_Office_Order_Training.pdf";
import club from "../../assets/pdf/Club.pdf";
import genNextLogo from '../../assets/photo/BGLLogo.png'

const Hamburger = () => {
  const [click, setClick] = React.useState(false);
  const [submenu, setSubmenu] = React.useState(""); // Track the currently open submenu

  const handleClick = () => setClick(!click);
  const closeMenu = () => {
    setClick(false);
    setSubmenu(""); // Close all submenus
  };

  const toggleSubmenu = (name) => {
    // If the clicked submenu is already open, close it; otherwise, open it
    setSubmenu(submenu === name ? "" : name);
  };

  return (
    <div className="hamburger">
      <div className={click ? "main-container" : ""} onClick={closeMenu} />
      <nav className="navbar" onClick={(e) => e.stopPropagation()}>
        <div className="nav-container">
          <NavLink exact to="/" className="nav-logo">
            BIPARD
          </NavLink>
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <div style={{ marginLeft: "20px", marginTop: "10px" }} className="vikshitcard">
                <img src={genNextLogo} alt="genNext Logo" />
                <a href="/genNextLab.html" target="_blank" rel="noreferrer">
                  Bihar GenNext Lab
                </a>
              </div>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                to="/"
                activeClassName="active"
                className="nav-links"
                onClick={closeMenu}
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <div
                className="nav-links"
                onClick={() => toggleSubmenu("academy")}
              >
                The Academy
                <i
                  className={
                    submenu === "academy"
                      ? "fa fa-chevron-up"
                      : "fa fa-chevron-down"
                  }
                ></i>
              </div>
              {submenu === "academy" && (
                <ul className="submenu">
                  <li>
                    <NavLink
                      exact
                      to="/academy/about"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      About BIPARD
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/academy/DGMessage"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      DG Message
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/academy/team"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Team
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/academy/gallery"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Gallery
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/academy/DGReview"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      DG Review
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/academy/knowledgepartner"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Knowledge Partner
                    </NavLink>
                  </li>
                </ul>
              )}
            </li>

            {/* Training Dropdown */}
            <li className="nav-item">
              <div
                className="nav-links"
                onClick={() => toggleSubmenu("training")}
              >
                Training
                <i
                  className={
                    submenu === "training"
                      ? "fa fa-chevron-up"
                      : "fa fa-chevron-down"
                  }
                ></i>
              </div>
              {submenu === "training" && (
                <ul className="submenu">
                  <li>
                    <NavLink
                      exact
                      to="/training/trainingcalendar"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Training Calendar
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/training/traininghistory"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Training History
                    </NavLink>
                  </li>
                  <li>
                    <a
                      exact
                      href={training_rule} target="_blank" rel="noreferrer"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Training Rule
                    </a>
                  </li>
                  <li>
                    <a
                      exact
                      href={Gad} target="_blank" rel="noreferrer"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Training Policies
                    </a>
                  </li>
                </ul>
              )}
            </li>

            {/* Facilities Dropdown */}
            <li className="nav-item">
              <div
                className="nav-links"
                onClick={() => toggleSubmenu("facilities")}
              >
                Facilities
                <i
                  className={
                    submenu === "facilities"
                      ? "fa fa-chevron-up"
                      : "fa fa-chevron-down"
                  }
                ></i>
              </div>
              {submenu === "facilities" && (
                <ul className="submenu">
                  <li>
                    <NavLink
                      exact
                      to="/academy/facilities/trainingcenter"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Training Center
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/academy/facilities/smartclassroom"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Smart Classroom
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/academy/facilities/computerlab"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Computer Lab
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/academy/facilities/hostel"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Hostel
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/academy/facilities/dinninghall"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Dinning Hall
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/academy/facilities/sports"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Sports/Gym
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/academy/facilities/yoga"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Yoga/PT
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/academy/facilities/healthcare"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Health Care
                    </NavLink>
                  </li>
                </ul>
              )}
            </li>

            {/* Publication Dropdown */}
            <li className="nav-item">
              <div
                className="nav-links"
                onClick={() => toggleSubmenu("publication")}
              >
                Publication
                <i
                  className={
                    submenu === "publication"
                      ? "fa fa-chevron-up"
                      : "fa fa-chevron-down"
                  }
                ></i>
              </div>
              {submenu === "publication" && (
                <ul className="submenu">
                  <li>
                    <NavLink
                      exact
                      to="/publication/magazine"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Magazine
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/publication/eBooks"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      eBook
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/publication/ready-reckoner"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Ready Reckoner
                    </NavLink>
                  </li>
                </ul>
              )}
            </li>

            {/* Governance Dropdown */}
            <li className="nav-item">
              <div
                className="nav-links"
                onClick={() => toggleSubmenu("governance")}
              >
                Governance
                <i
                  className={
                    submenu === "governance"
                      ? "fa fa-chevron-up"
                      : "fa fa-chevron-down"
                  }
                ></i>
              </div>
              {submenu === "governance" && (
                <ul className="submenu">
                  <li>
                    <NavLink
                      exact
                      to="/academy/governance/generalcouncil"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      General Council
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/academy/governance/MoA"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Memorandum of Association
                    </NavLink>
                  </li>
                </ul>
              )}
            </li>

            {/* Examination Dropdown */}
            <li className="nav-item">
              <div
                className="nav-links"
                onClick={() => toggleSubmenu("examination")}
              >
                Examination
                <i
                  className={
                    submenu === "examination"
                      ? "fa fa-chevron-up"
                      : "fa fa-chevron-down"
                  }
                ></i>
              </div>
              {submenu === "examination" && (
                <ul className="submenu">
                  <li>
                    <NavLink
                      exact
                      to="/examination/departmentalexam"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Departmental Exam
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/examination/cctexam"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      CCT Exam
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/examination/otherexam"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Other
                    </NavLink>
                  </li>
                </ul>
              )}
            </li>

            {/* Club Dropdown */}
            <li className="nav-item">
              <div
                className="nav-links"
                onClick={() => toggleSubmenu("clubs")}
              >
                Clubs
                <i
                  className={
                    submenu === "clubs"
                      ? "fa fa-chevron-up"
                      : "fa fa-chevron-down"
                  }
                ></i>
              </div>
              {submenu === "clubs" && (
                <ul className="submenu">
                  <li>
                    <NavLink
                      exact
                      to="/clubs/messclub"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Mess Club
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/clubs/protocolclub"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Protocol Club
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/clubs/sportsclub"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Sport Club
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/clubs/sanskriticlub"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Sanskriti Club
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/clubs/academicclub"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Academic Club
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/clubs/adventureclub"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Adventure & Trekking Club
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/clubs/protocolclub"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Protocol Club
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/clubs/documentationclub"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Documentation & I.T Club
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      exact
                      to="/clubs/bharatdarshanclub"
                      activeClassName="active"
                      className="nav-links"
                      onClick={closeMenu}
                    >
                      Bharat darshan Club
                    </NavLink>
                  </li>
                </ul>
              )}
            </li>

            <li className="nav-item">
              <NavLink
                exact
                to="/RTI"
                activeClassName="active"
                className="nav-links"
                onClick={closeMenu}
              >
                RTI
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                to="/visitus"
                activeClassName="active"
                className="nav-links"
                onClick={closeMenu}
              >
                Visit Us
              </NavLink>
            </li>
          </ul>
          <div className="nav-icon" onClick={handleClick}>
            <i className={click ? "fa fa-times" : "fa fa-bars"}></i>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Hamburger;
